import React, { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Link from 'next/link';
import { useBackCta } from 'src/hooks';
import { Button } from '../Button';
import * as S from './styles';

const msgs = defineMessages({
  home: { id: 'header_link_home' },
  back: { id: 'web_header_back' },
});

export const BackHeader: FC<{
  href?: string;
  onClick?: () => void;
  hideText?: boolean;
  beta?: boolean;
  betaText?: string;
}> = ({ href, onClick, hideText, beta, betaText }) => {
  const intl = useIntl();
  const logo = intl.formatMessage(msgs.home);
  const passedHrefCta = useBackCta(href);
  const backCta =
    onClick && !href
      ? {
          href: '',
          text: intl.formatMessage(msgs.back),
        }
      : passedHrefCta;

  const child = (
    <S.Content>
      <S.ArrowIcon name="backwards" />
      {!hideText && <S.Text>{backCta.text}</S.Text>}
    </S.Content>
  );

  return (
    <S.Header data-testid="header">
      <Link href={backCta.href} passHref legacyBehavior>
        <S.Redirect title={logo} aria-label={logo}>
          <S.LogoIcon name="memrise" />
        </S.Redirect>
      </Link>
      {onClick ? (
        <S.BackButton>
          <Button buttonType="tertiary" onClick={onClick} buttonSize="extraSmall">
            {child}
          </Button>
        </S.BackButton>
      ) : (
        <Link href={backCta.href} passHref legacyBehavior>
          <S.Redirect aria-label={backCta.text}>{child}</S.Redirect>
        </Link>
      )}
      {beta && (
        <S.BetaWrapper>
          <S.Beta
            data-testid="Beta-tag"
            href="https://memrise.zendesk.com/hc/en-us/articles/9314957339281"
            target="_blank"
            rel="noopener noreferrer"
          >
            {betaText && betaText + ` - `} Beta
          </S.Beta>
        </S.BetaWrapper>
      )}
    </S.Header>
  );
};
